/**
 * Fetch wrapper for ordering API calls.
 * Includes credentials for cookie auth.
 */
export function orderingFetch(url: string, options?: RequestInit): Promise<Response> {
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}
